import apiClient from '../axios';

export default {
    getPerfilUsuario(id) {
        return apiClient.get(`/usuarios/${id}`);
    },
    actualizarPerfilUsuario(id_usuario) {
        return apiClient.put('/usuario/perfil', id_usuario);
    },

    getbuscador(id_usuario) {
        return apiClient.get(`/detalle/usuario/${id_usuario}`);
    },
};